import * as React from 'react';
import cn from 'classnames';
import { FC } from 'react';
import { useTheme } from '../../../theme';
import { SafeHtml } from '@shared/ui';

interface Props {
	options: string[];
	className?: string;
}
export const OptionsList: FC<Props> = ({ options, className }) => {
	const { OptionsList: theme } = useTheme('InsurancePage');

	return (
		<ul className={cn(theme.list, className)}>
			{options.map(option => (
				<SafeHtml key={option} tag="li" html={option} />
			))}
		</ul>
	);
};
